// productpage buy area
var WDNPrices = function (config) {
  var parent = document.querySelector(config.scope_selector);

  // import and rename
  var toMoney = WDN.Money.format;

  var attrs = config.attrs;

  var _updateWDNPriceAttribute = function (price, comparePrice) {
    document.querySelectorAll(".buy-price").forEach(function (element) {
      element.setAttribute("data-price-cents", price);
      element.setAttribute("data-compare-price-cents", comparePrice);
    });
  };

  this.update = function (price, compare_price) {
    this.price = price;
    this.priceCompare = compare_price || 0;

    this.priceMoney = toMoney(this.price);
    this.priceCompareMoney = toMoney(this.priceCompare);

    this.onSale =
      this.priceCompare && this.priceCompare > this.price ? true : false;

    this.savings = this.onSale ? this.priceCompare - this.price : 0;
    this.savingsMoney = this.onSale
      ? toMoney(this.priceCompare - this.price)
      : 0;

    // Update parent container used to manipulate DOM
    parent.setAttribute(attrs.onSale, this.onSale);

    // 2023 wdn-price update
    _updateWDNPriceAttribute(this.price, this.priceCompare);
  };
};

// END productpage buy area

var ProductPage = {};
ProductPage.element = document.querySelector("wdn-product-page");
ProductPage.variant_input_element = ProductPage.element.querySelector(
  "[data-product-line-id]"
);
ProductPage.qty_input_element = ProductPage.element.querySelector(
  'input[name="quantity"]'
);

ProductPage.prices = new WDNPrices({
  attrs: {
    onSale: "data-variant-on-sale",
    price: "data-variant-price",
    compare_price: "data-variant-compare-price",
  },
  scope_selector: "wdn-product-page",
});

var WDNVariantSelection = function () {
  var toMoney = WDN.Money.format;

  var productJSON = JSON.parse(
    document.querySelector("[data-product-json]").innerText
  );
  var productOptionJSON = JSON.parse(
    document.querySelector("[data-product-options-json]").innerText
  );

  var hasVariantImages = false;
  var gallery = document.querySelector("#product_gallery");

  if (gallery) {
    if (gallery.querySelector("[data-image-for-variant-ids]")) {
      hasVariantImages = true;
    }
  }

  var getItemData = function (elem) {
    if (!elem) return;
    var item_data = elem.dataset;

    var formatted_data = {
      price: parseFloat(item_data.linePrice),
      priceCompare: parseFloat(item_data.lineComparePrice),
      quantity: parseFloat(item_data.lineQuantity),
      savings: parseFloat(item_data.savings),
      savings_percentage: parseFloat(item_data.savingsPercentage),
      variant_id: item_data.variantId,
      onSale: item_data.lineOnSale === "true" ? true : false,
      available: item_data.variantAvailable === "true" ? true : false,
    };

    formatted_data.priceMoney = toMoney(formatted_data.price);
    formatted_data.priceCompareMoney = toMoney(formatted_data.priceCompare);
    formatted_data.savingsMoney = toMoney(formatted_data.savings);

    return formatted_data;
  };

  var updatePrices = function (price, priceCompare) {
    ProductPage.prices.update(price, priceCompare);
  };

  var updateAvailability = function (available) {
    ProductPage.element.setAttribute("data-variant-available", available);
  };

  var updateVariantID = function (id) {
    ProductPage.variant_input_element.value = id;
    updateVariantImages(id);
  };

  var updateVariantQuantity = function (qty) {
    ProductPage.qty_input_element.value = qty;
  };

  var setVariantParam = function (variantID) {
    if (!variantID || isNaN(parseInt(variantID))) return;
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("variant", variantID);
    window.history.replaceState("", "", "?" + searchParams.toString());
  };

  var updateVariantImages = function (variantId) {
    if (!hasVariantImages) { return; }
    if (!variantId || variantId.length == 0) {
      return;
    }

    var variantImg = gallery.querySelector(
      '[data-image-for-variant-ids*="' + variantId + '"]'
    );

    gallery.querySelectorAll("img.visible").forEach((elem) => {
      elem.classList.remove("visible");
    });

    if (variantImg) {
      variantImg.classList.add("visible");
      if (WDN && WDN.Slider && WDN.Slider.list && WDN.Slider.list["product_gallery"]) {
        WDN.Slider.list["product_gallery"].moveToIdx(0);
      }
    }
  };

  ProductPage.element.addEventListener("variant:change:bulk", (event) => {});

  var handleInsaneVariantChange = function () {
    setTimeout(function () {
      var parent = document.querySelector("[data-variant-group-insane]");
      var option1 = parent
        .querySelector('[name="variant_selection"]:checked')
        .getAttribute("data-variant-id")
        .replace("option", "");
      var option2 = document.querySelector(".variant-option-input:checked");

      if (!option2) return;

      option1 = parseInt(option1) - 1;
      option2 = parseInt(option2.getAttribute("data-variant-index")) - 1;

      var option1Name = productOptionJSON[0].values[option1];
      var option2Name = productOptionJSON[1].values[option2];

      var variantName = option1Name + " / " + option2Name;

      var variantList = productJSON.variants;
      var activeVariant = variantList.find((elem) => {
        if (elem.title == variantName) return true;
      });

      var formVariantId = document.querySelector("[data-product-line-id]");
      formVariantId.value = activeVariant.id;
      setVariantParam(activeVariant.id);
    }, 100);
  };

  document.body.addEventListener(
    "variant:change:insane",
    handleInsaneVariantChange
  );

  var onVariantChange = function (elem) {
    var variant = getItemData(elem);
    if (!variant) return;

    updatePrices(variant.price, variant.priceCompare);
    updateAvailability(variant.available);

    if (!document.querySelector("[data-bulk-with-variant]")) {
      updateVariantID(variant.variant_id);
    }

    updateVariantQuantity(variant.quantity);

    if (document.querySelector("[data-variant-group-insane]")) {
      handleInsaneVariantChange(elem);
    }

    setVariantParam(variant.variant_id);
  };

  // Add initialized class (shows selected variant)
  ProductPage.element.classList.add("initialized");

  var listenForVariantChange = function () {
    variant_items = document.querySelectorAll(
      'input[name="variant_selection"]'
    );
    variant_items.forEach(function (element) {
      element.addEventListener("click", function () {
        onVariantChange(element);
      });
    });
  };

  var onBulkVariantChange = function () {
    setVariantParam(this.value);
    updateVariantID(this.value);
  };

  var listenForBulkVariantChange = function () {
    document
      .querySelectorAll(".variant-option-input")
      .forEach(function (input) {
        input.addEventListener("change", onBulkVariantChange);
      });
  };

  var forceVariantOneFromUrl = function () {
    var readConfig = function () {
      /*
        Finds and parses config if given in the DOM.
        Will not be in DOM, if not activated by merchant
        
        @input <script [..]>
        @output { "data": [...] }
     */
      var jsonDOMConfigNode = document.querySelector(
        "[data-preselect_first_variant_if_param_list]"
      );

      // if not found, i.e. not activated by merchant
      if (!jsonDOMConfigNode) {
        return false;
      }

      var jsonDOMConfig = JSON.parse(jsonDOMConfigNode.innerText);

      return jsonDOMConfig.preselect_first_variant_if_param_list;
    };

    var readTriggerParamList = () => {
      /*
        reads liquid settings in format e.g. 
        @input "fbad, googlead"
        @output ["fbad", "googlead"]
      */

      var rawList = readConfig();
      var parsedList = false;

      if (rawList && rawList.length > 0) {
        parsedList = rawList.replaceAll(" ", "").split(",");

        if (parsedList.length == 0) {
          parsedList = false;
        }
      }

      return parsedList;
    };

    /*
      Compare list from triggerParamList 
      with active URL to determine whether
      to return true / false for the force variant 1 selection
    */
    var checkActiveUrlForMatches = () => {
      var triggerParamList = readTriggerParamList();
      var forceVariantOne = false;

      if (triggerParamList && triggerParamList.length > 0) {
        var searchParams = new URLSearchParams(window.location.search);

        triggerParamList.forEach((param) => {
          if (searchParams.has(param)) {
            forceVariantOne = true;
          }
        });
      }

      return forceVariantOne;
    };

    /*

        ### usage:
        forceVariantOneFromUrl() => "true/false"

      */

    return checkActiveUrlForMatches();
  };

  window.addEventListener("DOMContentLoaded", function () {
    var variantLayout = document
      .querySelector("[data-variant-layout]")
      .getAttribute("data-variant-layout");
    var selectedVariant = document.querySelector(
      "input[name='variant_selection'][checked='checked']"
    );

    // List of variant layouts that allow preselect variant based on variant param
    var layoutsList = ["variant_advanced", "variant_standard"];
    var searchParams = new URLSearchParams(window.location.search);

    if (layoutsList.indexOf(variantLayout) > -1) {
      if (searchParams.has("variant")) {
        var selectedOption = document.querySelector(
          "[data-variant-id='" + searchParams.get("variant") + "']"
        );

        if (selectedOption) {
          selectedVariant = selectedOption;
          selectedOption.click();
        }
      }
    }

    // dont force variant 1, if variant is given by URL
    if (!searchParams.has("variant") && forceVariantOneFromUrl()) {
      var firstVariant = document.querySelector(
        '.productpage__variant-pick .variant__item input[type="radio"]'
      );
      if (firstVariant) {
        selectedVariant = firstVariant;
        firstVariant.click();
      }
    }

    if (variantLayout !== "variant_insane") {
      onVariantChange(selectedVariant);
    }

    listenForVariantChange();
    listenForBulkVariantChange();
  });
};

ProductPage.variant_selection = new WDNVariantSelection();
